import { Link } from "@smart/itops-sb-design-system-dom";

import { ConditionItem, getItemLabel } from "./utils";

export const ConditionLink = ({
  field,
  setCurrentField,
  removeMarkdownFormatting,
}: {
  field: ConditionItem | undefined;
  setCurrentField: (field: ConditionItem | null) => void;
  removeMarkdownFormatting?: boolean;
}) =>
  field ? (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      text={getItemLabel(field, removeMarkdownFormatting)}
      onClick={() => setCurrentField(field)}
    />
  ) : null;
